export default {"blank":"U562da_blank","cards":"U562da_cards","empty":"U562da_empty",}